<template>
	<div class="product-show">
		<!-- <div class="common-btn-area">
			<span class="btn" @click="$router.go(-1)"><i class="fas fa-undo"></i> 戻る</span>
		</div> -->
		<FunctionTitle :title="mainTitle" />
		<CommonFlame :title="title">
			<template v-if="!$vuetify.breakpoint.xs" v-slot:app-bar-btn>
				<v-btn v-if="edit_flg" color="primary" class="ml-2" @click="redirectToProductEdit">
					<v-icon class="mr-1">mdi-plus</v-icon>
					コピーして新規作成
				</v-btn>
				<v-btn
					v-if="edit_flg && product.status == 'ongoing'"
					color="primary"
					class="ml-2"
					@click="updateStatus('archived')"
				>
					<v-icon class="mr-1">mdi-archive</v-icon>
					アーカイブ
				</v-btn>
				<v-btn
					v-if="edit_flg && product.status == 'archived'"
					color="primary"
					class="ml-2"
					@click="updateStatus('ongoing')"
				>
					<v-icon class="mr-1">mdi-archive</v-icon>
					アーカイブ解除
				</v-btn>
				<TemplateDeleteDialog ref="deleteDialog" openBtnColor="primary" v-if="edit_flg">
					<template v-slot:button>
						<v-row justify="center">
							<v-btn class="ma-1" @click="deleteProduct" dense dark color="red"> 削除する </v-btn>
						</v-row>
					</template>
				</TemplateDeleteDialog>
			</template>

			<template v-if="$vuetify.breakpoint.xs">
				<v-btn v-if="edit_flg" color="secondary" class="ml-2" @click="redirectToProductEdit">
					<v-icon class="mr-1">mdi-plus</v-icon>
					コピーして新規作成
				</v-btn>
				<v-btn
					v-if="edit_flg && product.status == 'ongoing'"
					color="secondary"
					class="ml-2 mt-1"
					@click="updateStatus('archived')"
				>
					<v-icon class="mr-1">mdi-archive</v-icon>
					アーカイブ
				</v-btn>
				<v-btn
					v-if="edit_flg && product.status == 'archived'"
					color="secondary"
					class="ml-2 mt-1"
					@click="updateStatus('ongoing')"
				>
					<v-icon class="mr-1">mdi-archive</v-icon>
					アーカイブ解除
				</v-btn>
				<v-row no-gutters class="mt-1 ml-2" v-if="edit_flg">
					<TemplateDeleteDialog ref="deleteDialog" openBtnColor="secondary">
						<template v-slot:button>
							<v-row justify="center">
								<v-btn @click="deleteProduct" dense dark color="red"> 削除する </v-btn>
							</v-row>
						</template>
					</TemplateDeleteDialog>
				</v-row>
			</template>
			<v-card :tile="$vuetify.breakpoint.xs" elevation="0">
				<v-sheet elevation="0" class="pa-2">
					<table width="100%" class="show-dialog-table">
						<tbody>
							<tr>
								<th width="30%" class="font-weight-bold">製品番号</th>
								<td width="70%" class="edit-area">
									{{ product.product_code_prefix_ja + product.product_code }}
								</td>
							</tr>
							<tr>
								<th width="30%" class="font-weight-bold">製品名</th>
								<td width="70%" class="edit-area">
									{{ product.name }}
								</td>
							</tr>
							<tr>
								<th width="30%" class="font-weight-bold">品目接頭辞</th>
								<td width="70%" class="edit-area">
									{{ product.product_code_prefix_ja }}
								</td>
							</tr>
							<tr>
								<th width="30%" class="font-weight-bold">品目コード</th>
								<td width="70%" class="edit-area">
									{{ product.product_code }}
								</td>
							</tr>
							<tr>
								<th width="30%" class="font-weight-bold">製品カテゴリー</th>
								<td width="70%" class="edit-area">
									{{ product.product_category.name }}
								</td>
							</tr>
							<tr>
								<th width="30%" class="font-weight-bold">製品サブカテゴリー</th>
								<td width="70%" class="edit-area">
									{{ product.product_sub_category.name }}
								</td>
							</tr>
							<tr>
								<th width="30%" class="font-weight-bold">ステータス</th>
								<td width="70%" class="edit-area">
									{{ product.status_ja }}
								</td>
							</tr>
							<tr>
								<th width="30%" class="font-weight-bold">原価</th>
								<td width="70%" class="edit-area">
									{{ product.cost_price }}
								</td>
							</tr>
							<tr>
								<th width="30%" class="font-weight-bold">定価</th>
								<td width="70%" class="edit-area">
									{{ product.list_price }}
								</td>
							</tr>
							<tr>
								<th width="30%" class="font-weight-bold">通常販売価格</th>
								<td width="70%" class="edit-area">
									{{ product.standard_price }}
								</td>
							</tr>
							<tr>
								<th width="30%" class="font-weight-bold">製品仕様</th>
								<td width="70%" class="edit-area">
									{{ product.specification }}
								</td>
							</tr>
							<tr>
								<th width="30%" class="font-weight-bold">特定の仕様に属する</th>
								<td width="70%" class="edit-area">
									{{ isBelongsToSpecification }}
								</td>
							</tr>
						</tbody>
					</table>
				</v-sheet>
			</v-card>
		</CommonFlame>
	</div>
</template>

<script>
import axios from "axios"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"

import CommonFlame from "../shared/CommonFlame.vue"
import FunctionTitle from "../shared/FunctionTitle.vue"
import TemplateDeleteDialog from "../shared/TemplateDeleteDialog.vue"

export default {
	components: {
		CommonFlame,
		FunctionTitle,
		TemplateDeleteDialog,
	},
	data() {
		return {
			mainTitle: "製品",
			title: "製品詳細",
			product: {
				product_category: {},
				product_sub_category: {},
			},
			errors: [],
			id: this.$route.params.id,
			edit_flg: false,
		}
	},
	mounted() {
		authenticate.authenticateUser()
		this.fetchProduct()
	},
	methods: {
		redirectToProductEdit() {
			this.$router.push({ name: "product_edit", params: { id: this.id } })
		},
		deleteProduct() {
			const headers = authenticate.setHeader()

			axios
				.delete(`/erp/v1/products/${this.id}`, {
					headers,
				})
				.then((res) => {
					if (res.status == 204) {
						this.$store.commit("setFlash", {
							type: "notice",
							text: "製品情報を削除しました。",
						})
						this.$router.push({ name: "product_index" })
					}
				})
				.catch((err) => {
					const errors = errorHandling.errorResponse(err)
					if (Array.isArray(errors)) {
						this.errors = errors
					}
				})
		},
		fetchProduct() {
			const headers = authenticate.setHeader()
			axios
				.get(`/erp/v1/products/${this.id}`, { headers })
				.then((res) => {
					this.product = res.data.product
					this.edit_flg = res.data.edit_flg
					const product_code_num = res.data.product.product_code.match(/\d{1,}/)
					this.product.product_code = product_code_num[0]
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
					if (err.response.data.type == "redirect") {
						this.$router.push(err.response.data.route)
					}
				})
		},
		updateStatus(status) {
			const headers = authenticate.setHeader()

			axios
				.put(
					`/erp/v1/products/${this.id}`,
					{
						status: status,
					},
					{
						headers,
					}
				)
				.then((res) => {
					if (res.status == 200) {
						this.product.status_ja = res.data.product.status_ja
						this.product.status = res.data.product.status
						this.$store.commit("setFlash", {
							type: "notice",
							text: "ステータスを更新しました。",
						})
					}
				})
				.catch((err) => {
					const errors = errorHandling.errorResponse(err)
					if (Array.isArray(errors)) {
						this.errors = errors
					}
				})
		},
	},
	computed: {
		isBelongsToSpecification() {
			if (this.product.wildcard == false) {
				return "属する"
			} else {
				return "属しない"
			}
		},
	},
}
</script>

<style lang="scss" scoped>
.edit-area {
	display: flex;
	width: 100%;
	justify-content: space-between;
}
</style>
